// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__3tVLo","title":"AfterBackImages_title__2dcK3","images":"AfterBackImages_images__37pF8"};